export const NEXT_DAY_RESERVATION_CUTOFF_HOUR_JST = 17;

const twoDigit = (value: number): string => String(value).padStart(2, "0");

export const NEXT_DAY_RESERVATION_CUTOFF_LABEL_JST = `${twoDigit(NEXT_DAY_RESERVATION_CUTOFF_HOUR_JST)}:00`;
